"use client";

import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { useAuthStore } from "@/lib/store";
import { useTranslation } from "@/lib/hooks/useTranslation";
import { toast } from "sonner";
import { Link } from "@/components/LocaleLink";
const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";
export function ToSUpdateModal() {
  const {
    user,
    accessToken,
    setUser
  } = useAuthStore();
  const {
    locale
  } = useTranslation();
  const fr = locale === "fr";
  const [submitting, setSubmitting] = useState(false);

  // Show modal if user is loaded AND has not yet accepted the updated terms
  const open = Boolean(user && !user.tos_accepted_at);
  const handleAccept = async () => {
    if (!accessToken || !user) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/v1/users/me/accept-tos`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      if (!res.ok) throw new Error("accept-tos failed");
      const data = await res.json();
      setUser({
        ...user,
        tos_accepted_at: data.accepted_at
      });
    } catch {
      toast.error(fr ? "Erreur. Réessaie." : "Error. Try again.");
    } finally {
      setSubmitting(false);
    }
  };
  if (!user) return null;
  return <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" onPointerDownOutside={e => e.preventDefault()} onEscapeKeyDown={e_0 => e_0.preventDefault()}>
        <DialogHeader>
          <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
            <ShieldCheck className="h-5 w-5 text-primary" />
          </div>
          <DialogTitle>
            {fr ? "Mise à jour de nos conditions" : "Updated Terms"}
          </DialogTitle>
          <DialogDescription className="space-y-2 pt-2" asChild>
            <div>
              <p>
                {fr ? "Velyq a mis à jour ses conditions concernant le traitement de ton CV :" : "Velyq has updated its terms regarding CV processing:"}
              </p>
              <ul className="list-disc space-y-1 pl-5 text-sm">
                <li>
                  {fr ? "Analyse via OpenAI / Gemini (États-Unis)" : "Analysis via OpenAI / Gemini (United States)"}
                </li>
                <li>
                  {fr ? "Conservation 30 jours pour les analyses pré-inscription" : "30-day retention for pre-signup analyses"}
                </li>
                <li>
                  {fr ? "Suppression à la demande à tout moment" : "Deletion on request at any time"}
                </li>
              </ul>
              <p className="pt-1">
                <Link href="/privacy" className="text-primary underline-offset-4 hover:underline">
                  {fr ? "Politique de confidentialité complète →" : "Full privacy policy →"}
                </Link>
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleAccept} disabled={submitting}>
            {submitting ? fr ? "Enregistrement…" : "Saving…" : fr ? "J'accepte" : "I accept"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
}